/* eslint-disable radix */
import update from 'immutability-helper';
import { userId } from '../currentUser/currentUser.reducer';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_PROJECT = 'ADD_LOCAL_PROJECT';
export const REMOVE_LOCAL_PROJECT = 'REMOVE_LOCAL_PROJECT';
export const API_LOAD_PROJECTS = 'API_LOAD_PROJECTS';
export const API_REMOVE_PROJECT = 'API_REMOVE_PROJECT';
export const API_CREATE_PROJECT = 'API_CREATE_PROJECT';
export const API_UPDATE_PROJECT = 'API_UPDATE_PROJECT';
export const API_CREATE_ASSIGN_PROJECT = 'API_CREATE_ASSIGN_PROJECT';
export const API_REMOVE_ASSIGN_PROJECT = 'API_REMOVE_ASSIGN_PROJECT';

const API_LOAD_PROJECTS_FAILED = 'API_LOAD_PROJECTS_FAILED';
const API_LOAD_PROJECTS_LOADING = 'API_LOAD_PROJECTS_LOADING';
const API_LOAD_PROJECTS_LOADED = 'API_LOAD_PROJECTS_LOADED';
const API_REMOVE_PROJECT_FAILED = 'API_REMOVE_PROJECT_FAILED';
const API_REMOVE_PROJECT_LOADING = 'API_REMOVE_PROJECT_LOADING';
const API_REMOVE_PROJECT_SUCCESS = 'API_REMOVE_PROJECT_SUCCESS';
const API_CREATE_PROJECT_FAILED = 'API_CREATE_PROJECT_FAILED';
const API_CREATE_PROJECT_LOADING = 'API_CREATE_PROJECT_LOADING';
const API_CREATE_PROJECT_SUCCESS = 'API_CREATE_PROJECT_SUCCESS';
const API_UPDATE_PROJECT_FAILED = 'API_UPDATE_PROJECT_FAILED';
const API_UPDATE_PROJECT_LOADING = 'API_UPDATE_PROJECT_LOADING';
const API_UPDATE_PROJECT_SUCCESS = 'API_UPDATE_PROJECT_SUCCESS';

const API_CREATE_ASSIGN_PROJECT_LOADING = 'API_CREATE_ASSIGN_PROJECT_LOADING';
const API_CREATE_ASSIGN_PROJECT_SUCCESS = 'API_CREATE_ASSIGN_PROJECT_SUCCESS';
const API_REMOVE_ASSIGN_PROJECT_LOADING = 'API_REMOVE_ASSIGN_PROJECT_LOADING';
const API_REMOVE_ASSIGN_PROJECT_SUCCESS = 'API_REMOVE_ASSIGN_PROJECT_SUCCESS';

const defaultState = { projects: [], loading: false };
const emptyProject = () => ({ id: getId(), name: '', isRemoving: false });
const mapDefaults = project => ({ ...emptyProject(), ...project });

// eslint-disable-next-line object-curly-newline
export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_PROJECTS_LOADED:
      return update(state, {
        loading: { $set: false },
        projects: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_PROJECTS_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_PROJECTS_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_PROJECT:
      return update(state, { projects: { $push: [{...emptyProject(), active: true}] } });
    case API_REMOVE_PROJECT_SUCCESS:
    case REMOVE_LOCAL_PROJECT:
      return update(state, { projects: { $splice: [[indexById(id, state.projects), 1]] } });
    case API_REMOVE_PROJECT_FAILED:
      return update(state, { projects: { [indexById(id, state.projects)]: { removing: { $set: false } } } });
    case API_REMOVE_PROJECT_LOADING:
      return update(state, { projects: { [indexById(id, state.projects)]: { removing: { $set: true } } } });
    case API_CREATE_PROJECT_FAILED:
      return update(state, { projects: { [indexById(resource.id, state.projects)]: { saving: { $set: false } } } });
    case API_CREATE_PROJECT_LOADING:
      return update(state, { projects: { [indexById(resource.id, state.projects)]: { saving: { $set: true } } } });
    case API_CREATE_PROJECT_SUCCESS:
      return update(state, { projects: { $splice: [[indexById(replaceId, state.projects), 1, response]] } });
    case API_CREATE_ASSIGN_PROJECT_LOADING:
    case API_REMOVE_ASSIGN_PROJECT_LOADING:
      return update(state, { projects: { [indexById(id || resource.id, state.projects)]: { saving: { $set: true } } } });
    case API_CREATE_ASSIGN_PROJECT_SUCCESS:
      return update(state, { projects: { $splice: [[indexById(response.id, state.projects), 1, response]] } });
    case API_REMOVE_ASSIGN_PROJECT_SUCCESS:
      const index = indexById(id || response.id, state.projects);
      return update(state, {
        projects: {
          [index]: {
            employees: { $set: state.projects[index].employees.filter(e => e.id !== Number.parseInt(userId())) },
            saving: { $set: false },
          },
        },
      });
    default:
      return state;
  }
};

const sortName = (a, b) => {
    const nameA = a.name.toUpperCase(); // ignore upper and lowercase
    const nameB = b.name.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }

    // names must be equal
    return 0;
};

export const projects = (state, year) => {
  let projects = state.projects.projects;
  const yearAbbr = new RegExp(`${year}[-a-zA-Z ].*`);
  const fullYear = `20${year}`;

  if(year !== undefined && year !== "") {
    projects = projects.filter(e => yearAbbr.test(e.name) || e.name.startsWith(fullYear))
  }
  return projects.sort(sortName);
};

export const activeProjects = state => state.projects.projects.filter(e => e.active).sort(sortName);
export const loading = state => state.projects.loading;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/projects/projects.reducer.js